import React from 'react';
import { styled } from '@mui/material/styles';
import TradeList from './TradeList';
import TradeSummary from './TradeSummary';
import DailyWinLossChart from './DailyWinLossChart';
import DailyProfitLossChart from './DailyProfitLossChart';
import PerformanceBySymbol from './PerformanceBySymbol';
// import { accountList } from './AccountList';
import Positions from './Positions';
import Version from './Version';
import Alerts from './Alerts';
import { Accordion, AccordionSummary, AccordionDetails,
    CircularProgress, CssBaseline, Grid, InputLabel, Box, Button, Backdrop,
    FormControl, Switch, AppBar, Toolbar, IconButton,
    Snackbar, Alert, Select, Dialog,
    Typography, TextField
} from '@mui/material'
import { Refresh, AddCircle, RemoveCircle, Download, Check, Edit } from '@mui/icons-material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import WebSocketHandler from './WebSocketHandler';
import retryOperation from './retry.js';
import PageVisibility from 'react-page-visibility';
import { useWakeLock } from 'react-screen-wake-lock';
import { useSearchParams, NavLink } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CandlestickChartOutlinedIcon from '@mui/icons-material/CandlestickChartOutlined';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import LockIcon from '@mui/icons-material/Lock';

const PREFIX = 'Dashboard';

const classes = {
    formControl: `${PREFIX}-formControl`,
    selectEmpty: `${PREFIX}-selectEmpty`,
    container: `${PREFIX}-container`,
    textField: `${PREFIX}-textField`,
    backdrop: `${PREFIX}-backdrop`,
    tile: `${PREFIX}-tile`
};

const StyledPageVisibility = styled(PageVisibility)((
    {
        theme
    }
) => ({
    [`& .${classes.formControl}`]: {
      margin: theme.spacing(1),
      minWidth: 120,
    },

    [`& .${classes.selectEmpty}`]: {
      marginTop: theme.spacing(2),
    },

    [`& .${classes.container}`]: {
      display: 'flex',
      flexWrap: 'wrap',
    },

    [`& .${classes.textField}`]: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },

    [`& .${classes.backdrop}`]: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },

    [`& .${classes.tile}`]: {
        padding: 2
    }
}));

const dayjs = require('dayjs');

export default function Dashboard() {
    const apiURLPrefix = process.env.REACT_APP_API_PREFIX || '/api'
    const midaURLPrefix = '/mida';

    const [initialized, setInitialized] = React.useState(false);
    const [accountList, setAccountList] = React.useState([]);
    const [switchChecked, setSwitchChecked] = React.useState(false);
    const [botEnabled, setBotEnabled] = React.useState(false);
    const [risk, setRisk] = React.useState(0.5);
    const [status, setStatus ] = React.useState({});
    const setStatusMessage = (message, severity) => {
        setStatus({message: message, severity: severity ? severity : 'success'})
    }
    const [selectedAccount, setAccount] = React.useState();
    const [description, setDescription] = React.useState('');
    const [editingNickname, setEditingNickname] = React.useState(false);
    const [from, setFrom] = React.useState();
    const [to, setTo] = React.useState();
    const [symbolFilter, setSymbolFilter] = React.useState();
    const [tradeSummary, setTradeSummary] = React.useState();
    // const [positions, setPositions] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [authorized, setAuthorized] = React.useState(false);
    const [displayMode, setDisplayMode] = React.useState('trade');
    const [webSocketHandler, setWebSocketHandler] = React.useState();
    const [tradingConfiguration, setTradingConfiguration] = React.useState({});
    const [positionChangeTime, setPositionChangeTime] = React.useState();
    const [positionData, setPositionData] = React.useState([]);
    const [liveData, setLive] = React.useState(false);
    const { isSupported, request, } = useWakeLock({
        reacquireOnPageVisible: true,
    });
    const [lockButtonVisible, setLockButtonVisible] = React.useState(true);
    const [searchParams] = useSearchParams();
    const symbol = searchParams.get('symbol');

    const handleDisplayMode = (event, newDisplayMode) => {
        setDisplayMode(newDisplayMode);
    };

    const updatePosition = () => {
        setPositionChangeTime(dayjs())
    }

    const botToggleHandler = (event) => {
        const [ provider ] = selectedAccount.split(':');
        fetch(`${apiURLPrefix}/${provider}/admin/bot-enabled`, {
            method: 'PUT',
            body: JSON.stringify(event.target.checked),
            headers: { 'Content-Type': 'application/json' },
        }).then(response => response.json())
        .then(data => {
            const enabled = data === 'true' || data === true;
            setBotEnabled(enabled);
            fetch(`${midaURLPrefix}/admin/bot-enabled`, {
                method: 'POST',
                body: JSON.stringify({ accountId: provider, enabled }),
                headers: { 'Content-Type': 'application/json' },
            });
        }).catch(() => setBotEnabled(!event.target.checked));
    };

    const switchChangeHandler = (event) => {

        const [ provider ] = selectedAccount.split(':');
        fetch(`${apiURLPrefix}/${provider}/admin/engine`, {
            method: 'PUT',
            body: JSON.stringify(event.target.checked),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(response => response.json())
        .then(data => {
            setSwitchChecked(data);
            fetch(`${midaURLPrefix}/admin/day-trading`, {
                method: 'POST',
                body: JSON.stringify({ enabled: data, }),
                headers: { 'Content-Type': 'application/json', },
            });
        }).catch(error => {
            setSwitchChecked(!event.target.checked);
            console.log(error);
        })
    }
    const onChangeHandler = (event) => {
        switch(event.target.id) {
            case "accountSelector": {
                const newAccount = event.target.value;
                setAccount(newAccount);
                localStorage.setItem('selectedAccount', newAccount);
                const [provider] = newAccount.split(':');
                const acc = accountList.find(a => a.provider === provider);
                setDescription(acc?.alias || '');
                break;
            }
            case "from":
                setFrom(dayjs(event.target.value));
                break;
            case "to":
                setTo(dayjs(event.target.value));
                break;
        }
    };
    const saveDescription = () => {
        if (!selectedAccount) return;
        const [provider] = selectedAccount.split(':');
        fetch(`${apiURLPrefix}/admin/trader/${provider}/description`, {
            method: 'PUT',
            headers: { 'Content-Type': 'text/plain' },
            body: description,
        }).then(() => {
            setAccountList(prev => prev.map(a =>
                a.provider === provider ? {...a, alias: description || a.accountId} : a
            ));
            setEditingNickname(false);
        }).catch(e => setStatusMessage(`Failed to save description: ${e}`, 'error'));
    };

    const visibilityHandler = isVisible => {
        if (webSocketHandler) {
            if (isVisible) {
                webSocketHandler.connect();
                if (selectedAccount) {
                    const [ provider ] = selectedAccount.split(':');
                    fetch(`${midaURLPrefix}/admin/account/${provider}`);
                }
            }
            else {
                if (selectedAccount) {
                    const [ provider ] = selectedAccount.split(':');
                    fetch(`${midaURLPrefix}/admin/account/${provider}`, {
                        method: 'DELETE'
                    });
                }
                webSocketHandler.close();
            }
        }
    }
    const handleLock = () => {
        if (isSupported) {
            request().then(() => {
                setLockButtonVisible(false);
            }).catch((err) => {
                setStatusMessage(`Failed to acquire wake lock: ${err.message}`, 'error');
            });
        } else {
            setStatusMessage('Wake Lock API not supported in this browser.', 'warning');
        }
    }
    React.useEffect(()=>{
        const d = dayjs();
        setFrom(d);
        setTo(d);
        setLoading(true);
        retryOperation(() => fetch(`${apiURLPrefix}/admin/trader/configuration`).then(response => {
            if (response.status === 401 || response.ok) {
                return response.json();
            }
            throw response.statusText
        }), 1000, 10)
        .then(response => {
            setInitialized(true);
            if (response.status === 401) {
                setAuthorized(false)
                throw response;
            }
            setAuthorized(true);
            return response;
        })
        .then(configuration => {
            var arr = configuration.accountList.map(account => {
                return {
                    id: account.id,
                    provider: account.ctraderId,
                    accountId: account.ctraderId,
                    alias: account.description || account.accountNumber,
                    shortcut: true,
                    tradingSwitchEnabled: true
                }
            }).sort((a, b) => a.id - b.id);
            setTradingConfiguration(configuration);
            setAccountList(arr);
            const saved = localStorage.getItem('selectedAccount');
            const initial = saved && arr.find(a => `${a.provider}:${a.accountId}` === saved)
                ? saved
                : `${arr[0].provider}:${arr[0].accountId}`;
            setAccount(initial);
            const [initialProvider] = initial.split(':');
            setDescription(arr.find(a => a.provider === initialProvider)?.alias || '');
            return initialProvider;
        })
        .then(provider => fetchData(provider))
        .then(() => setLoading(false))
        .catch(error => {
            setLoading(false);
            let msg = error;
            if (typeof error === "object") {
                msg = error.statusText
            }
            setStatusMessage(msg, "error");
        });
        return () => {
            if (webSocketHandler) {
                webSocketHandler.close();
            }
        }
    }, [initialized]);
    React.useEffect(() => {
        if (selectedAccount && from && to) {
            const [provider] = selectedAccount.split(':');
            fetchData(provider);
        }
    }, [from, to]);

    React.useEffect(()=>{
        if (selectedAccount) {
            const [ provider ] = selectedAccount.split(':');
            setWebSocketHandler(new WebSocketHandler(tradingConfiguration.wsUrl, provider));
            setTradeSummary(null);
            fetchData(provider);
            retryOperation(() => fetch(`${apiURLPrefix}/${provider}/admin/configuration`)
                .then(response=>response.json())
                .then(data=>{
                    console.log(data);
                    setSwitchChecked(data.isDayTrading);
                    setBotEnabled(!!data.botEnabled);
                    setRisk(data.riskPercentage);
                    setLive(true);
                }), 1000, 5)
                .then(() => retryOperation(() => fetch(`${midaURLPrefix}/admin/account/${provider}`), 1000, 5));
        }
    }, [selectedAccount]);


    // const positionEventHandler = (event) => {
    //     if (event.type === 'PositionList') {
    //         setPositions(event.positions);
    //     }
    // }

    const downloadTrades = (e) => {
        e.stopPropagation();
        const [ provider ] = selectedAccount.split(':');
        window.location.href = `${apiURLPrefix}/${provider}/trades/download?from=${dayjs(from).format('YYYY-MM-DD')}T00:00:00&to=${dayjs(to).format('YYYY-MM-DD')}T23:59:59`;
    };

    const fetchData= (provider) => {
        const tradesPromise = fetch(`${apiURLPrefix}/${provider}/trades?from=${dayjs(from).format('YYYY-MM-DD')}T00:00:00&to=${dayjs(to).format('YYYY-MM-DD')}T23:59:59`).then(data => {
                return data.json()
            }).then(summary => {
                setTradeSummary(summary);
            });
        return Promise.resolve(tradesPromise);
    }

    const refresh = () => {
        if (selectedAccount) {
            const [ provider, account ] = selectedAccount.split(':');
            setLoading(true)
            retryOperation(() => fetchData(provider, account), 1000, 5)
                .then(() => setLoading(false));
        }
    }

    // const switchEnabled = () => {
    //     if (selectedAccount) {
    //         const [ provider ] = selectedAccount.split(':');
    //         return _.find(accountList, a => a.provider === provider && a.tradingSwitchEnabled)
    //     }
    // }

    const removeAccount = () => {
        if (selectedAccount) {
            if (accountList.length == 1) {
                setStatusMessage('Cannot remove last account')
                return
            }
            const [ provider ] = selectedAccount.split(':');
            fetch(`${apiURLPrefix}/admin/trader/remove/${provider}`, {
                method: 'DELETE'
            }).then((response) => {
                if (response.status === 200) {
                    setStatusMessage('Account deleted');
                    fetch(`${midaURLPrefix}/admin/account/${provider}`, { method: 'DELETE' });
                    const newList = accountList.filter(a => {
                        return a.provider != provider
                    })
                    setAccountList(newList);
                    setAccount(`${newList[0].provider}:${newList[0].accountId}`);
                }
            })
        }
    }

    return (
        <StyledPageVisibility onChange={visibilityHandler}>
            <div className={classes.root}>
            <CssBaseline />
            <main className={classes.content}>
            <Backdrop className={classes.backdrop} sx={{zIndex: 100}} open={!authorized && loading}><CircularProgress size={60} thickness={5} indeterminate="true" /></Backdrop>
            <Dialog fullscreen open={initialized && !authorized && !loading}><Button variant="contained" href={`${apiURLPrefix}/auth/trader/login`}>Click to Login</Button></Dialog>
            {displayMode === "info" && <AppBar position="fixed" style={{bottom: 0, top: 'auto'}}>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid size={{xs: 6, sm: "auto"}}>
                        <Toolbar>
                            <IconButton onClick={refresh}>
                            <Refresh/>
                            </IconButton>
                            Day{<Switch checked={switchChecked} onChange={switchChangeHandler} />}
                            Bot{<Switch checked={botEnabled} onChange={botToggleHandler} />}
                        </Toolbar>
                    </Grid>
                    <Grid size={{xs: 6, md: "auto"}} sx={{pr: 2}}>
                        <Typography variant="body2" color="text.secondary" align="right">
                            Risk {risk}% {tradeSummary ? `($${(tradeSummary.currentBalance * risk / 100).toFixed(2)})` : ''}
                        </Typography>
                    </Grid>
                </Grid>
            </AppBar>}
            <Snackbar open={status.message != null} onClose={()=>{setStatusMessage(null)}} 
                autoHideDuration={6000} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <Alert variant="filled" severity={status.severity}>{status.message}</Alert>
            </Snackbar>
            <AppBar container position="fixed" style={{background: 'none' ,top: 0, bottom: 'auto'}}>
            <Grid container justifyContent="space-between" alignItems="center" sx={{marginBottom: 2, width: '100%'}}>
                {symbol && <Grid justifyContent="flex-start" alignItems="center" size={2}>
                    <NavLink style={()=>{ return {color: '#fff', textDecoration: 'none'};}} to="/">
                        <ArrowBackIosIcon />
                    </NavLink>
                </Grid>}
                {!symbol &&
                <Grid container size={{xs: 2, md: 3}} justifyContent="flex-start" alignItems="center">
                    <ToggleButtonGroup
                        size="small"
                        value={displayMode}
                        exclusive
                        onChange={handleDisplayMode}
                        aria-label="display mode"
                    >
                        <ToggleButton value="trade" aria-label="chart mode">
                            <CandlestickChartOutlinedIcon />
                        </ToggleButton>
                        <ToggleButton value="info" aria-label="trade mode">
                            <InfoOutlinedIcon />
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Grid>}
                <Grid container justifyContent="flex-end" alignItems="center" size={{xs: 8, md: 4}}>
                    {lockButtonVisible && <Grid container justifyContent="flex-end" alignItems="center" lg={10}>
                        <IconButton onClick={handleLock} title="Keep Screen Awake">
                            <LockIcon color="primary" />
                        </IconButton>
                    </Grid>}
                    <Version version={tradingConfiguration.version}/>
                </Grid>
            </Grid>
            </AppBar>
            <Grid container id="foo1" spacing={2} style={{marginTop: 65, marginBottom: 80}} sx={{width: '100%'}}>
            <Grid container spacing={3} alignItems="flex-end" size={12}>
            {displayMode === "info" &&
            <Grid container alignItems="center" size={{ xs: 12, md: 6 }}> 
                <Grid size={{ xs: 9, sm: 6, md: 8 }}>
                    <FormControl variant="outlined" fullWidth>
                    <InputLabel shrink id="account-label">
                        Account
                    </InputLabel>
                    <Select 
                        labelId="account-label"
                        id="accountSelector" 
                        native
                        label="Account"
                        variant="outlined"
                        value={selectedAccount}
                        onChange={onChangeHandler} 
                        >
                        {/* <option key="none" value="" >Select account</option> */}
                    {accountList && accountList.map(account => {
                        return <option key={account.accountId} value={account.provider+':'+account.accountId}>{account.accountId} - {account.alias}</option>
                    })}
                    </Select>
                    </FormControl>
                </Grid>
                <Grid container justifyContent="flex-start" size={{ xs: 3, sm: "auto"}}>
                    <Grid size={{ xs: 4, sm: "auto" }}>
                        <IconButton href={`${apiURLPrefix}/admin/trader/register`}>
                            <AddCircle color="primary" />
                        </IconButton>
                    </Grid>
                    <Grid size={{ xs: 4, sm: "auto" }}>
                        <IconButton onClick={() => {removeAccount(selectedAccount)}}>
                            <RemoveCircle color="primary" />
                        </IconButton>
                    </Grid>
                    <Grid size={{ xs: 4, sm: "auto" }}>
                        <IconButton onClick={() => setEditingNickname(true)} title="Edit nickname">
                            <Edit color="primary" />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>}
            {displayMode === "info" && editingNickname &&
            <Grid container alignItems="center" size={{ xs: 12, md: 6 }}>
                <Grid size="grow">
                    <TextField
                        label="Nickname"
                        variant="outlined"
                        size="small"
                        fullWidth
                        autoFocus
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        onBlur={saveDescription}
                        onKeyDown={e => { if (e.key === 'Enter') saveDescription(); if (e.key === 'Escape') setEditingNickname(false); }}
                        inputProps={{ maxLength: 64 }}
                    />
                </Grid>
                <Grid size="auto">
                    <IconButton onClick={saveDescription} title="Save nickname">
                        <Check color="primary" />
                    </IconButton>
                </Grid>
            </Grid>}
            {/* <Grid item container xs justifyContent="flex-start"> */}
            {!symbol && displayMode === "info" && (
                <>
            <Grid size={{ xs: 12, sm: 6 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        id="from"
                        label="From"
                        // type="date"
                        // variant="outlined"
                        value={dayjs(from)}
                        className={classes.textField}
                        onChange={(newValue) => {
                            setFrom(dayjs(newValue));
                        }} 
                        // InputLabelProps={{
                        //     shrink: true,
                        // }}
                        style={{margin: 0}}
                        // slotProps={{textfield: { variant: 'outlined' }}}
                    />
                    <Button variant="outlined" style={{margin: 10}} onClick={()=>{setFrom(dayjs()); setTo(dayjs());}}>Today</Button>
                    <DatePicker
                        id="to"
                        label="To"
                        // type="date"
                        // variant="outlined"
                        value={to}
                        // value={to.format('YYYY-MM-DD')}
                        className={classes.textField}
                        onChange={(newValue) => {
                            setTo(dayjs(newValue));
                        }} 
                        InputLabelProps={{
                            shrink: true,
                        }}
                        style={{margin: 0}}
                        slotProps={{textfield: { variant: 'outlined' }}}
                    />
                </LocalizationProvider>
            </Grid>
            </>
            )}
            </Grid>
            {!symbol && displayMode === "info" && (
            <Grid size={12}>
                <Box>Summary</Box>
                <Box>
                    <TradeSummary summary={tradeSummary} />
                </Box>
            </Grid>
            )}
            {displayMode === "trade" &&
            <Grid size={12}>
                <Positions tradingConfiguration={tradingConfiguration} wsHandler={webSocketHandler} 
                    setLoading={setLoading} 
                    setStatusMessage={setStatusMessage} refresh={refresh} 
                    selectedAccount={selectedAccount} 
                    setPositionData={setPositionData}
                    updatePosition={updatePosition}
                    positionChangeTime={positionChangeTime}
                    liveData={liveData} />
            </Grid>}
            <Grid style={{marginBottom: '40px'}} size={12}>
            {displayMode === "trade" &&
            <>
            <Alerts wsHandler={webSocketHandler} authorized={authorized} setStatusMessage={setStatusMessage} selectedAccount={selectedAccount} 
                slackWebhookUrl={tradingConfiguration.slackWebhookUrl}
                riskAmount={tradeSummary ? tradeSummary.currentBalance*risk/100 : 0}
                riskPercentage={risk}
                from={from} to={to} 
                updatePosition={updatePosition} 
                positionData={positionData} 
                liveData={liveData} />
            </>
            }
            {!symbol && displayMode === "info" && (
                <>
            <Accordion>
                <AccordionSummary>
                    <Typography variant="body1">Performance By Symbol</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <PerformanceBySymbol filter={[symbolFilter, setSymbolFilter]} trades={tradeSummary ? tradeSummary.trades : []} />
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary>
                    <Typography variant="body1">Daily Chart</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1} justifyContent='space-around'>
                    <Grid
                        size={{
                            md: 6,
                            sm: "grow",
                            xs: 12
                        }}>
                    <DailyWinLossChart trades={tradeSummary ? tradeSummary.trades : []} />
                    </Grid>
                    <Grid
                        size={{
                            md: 6,
                            sm: "grow",
                            xs: 12
                        }}>
                    <DailyProfitLossChart trades={tradeSummary ? tradeSummary.trades : []} />
                    </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary>
                    <Typography variant="body1" sx={{flexGrow: 1}}>Trades</Typography>
                    <IconButton size="small" onClick={downloadTrades} disabled={!tradeSummary}><Download fontSize="small" /></IconButton>
                </AccordionSummary>
                <AccordionDetails>
                    <TradeList symbolFilter={symbolFilter} trades={tradeSummary ? tradeSummary.trades : []} />
                </AccordionDetails>
            </Accordion>
            </>
            )}
            </Grid>
            </Grid>
            </main>
            </div>
        </StyledPageVisibility>
    );

}
